import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment } from "react";
import { ConfigurationTranslationController } from "@plansoft-configuration-renderer/localization";
import { ConfigurationObjectContext } from "../context/ConfigurationObjectContext";
import { ConfigurationPathContext } from "../context/ConfigurationPathContext";
import { useCsCfgObject } from "../hooks/useCsCfgObject";
// import { useSubscribeToPath } from "../hooks/useSubscribeToPath";
import { ConfigurationPathController } from "./ConfigurationPathController";
/**
 * Renders a sub configuration
 * @category Controller
 * @param props
 * @returns
 */
export function SubConfigurationController(props) {
    const { cfgObject, children, persist, FallbackUi = Fragment } = props;
    // the object is a stub and missing attributes, render the controller which loads additional selectors
    if (!cfgObject.attributes) {
        return (_jsx(ConfigurationPathController, { persist: persist, path: cfgObject.path, FallbackUi: FallbackUi, children: _jsx(SubConfigurationControllerInner, { children: children }) }));
    }
    // if the attributes are already there, we can render the sub configuration as is
    return (_jsx(SubConfigurationControllerSubscriber, { cfgObject: cfgObject, children: children }));
}
SubConfigurationController.displayName = "SubConfigurationController";
function SubConfigurationControllerSubscriber(props) {
    const { cfgObject, children } = props;
    // const parentPath = useContext(ConfigurationPathContext);
    // manage selectors for the path
    // useSubscribeToPath(parentPath);
    return (_jsx(ConfigurationPathContext.Provider, { value: cfgObject.path, children: _jsx(ConfigurationObjectContext.Provider, { value: cfgObject, children: _jsx(SubConfigurationControllerInner, { children: children }) }) }));
}
/**
 * We need access to the cfg object including the attributes
 * @param param0
 * @returns
 */
function SubConfigurationControllerInner({ children, }) {
    const cfgObject = useCsCfgObject();
    return (_jsx(ConfigurationTranslationController, { cfgObject: cfgObject, children: children }));
}
SubConfigurationControllerInner.displayName = "SubConfigurationControllerInner";
//# sourceMappingURL=SubConfigurationController.js.map